import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // <-- Импортируем хук перевода
import './Sidebar.css';
import { doLogout } from "../../api/keycloak";
import icon from "../../assets/log-out.png";
import brainIcon from "../../assets/brain3.png";
import { useLeadForm } from "../../hooks/useLeadForm";
import LeadModal from "../LeadModal/LeadModal";


const Sidebar = ({ tabs, activeTab, onTabClick }) => {
  const { t } = useTranslation("sidebar"); // <-- Инициализируем наш namespace
  const [isOpen, setIsOpen] = useState(false);
  const leadFormState = useLeadForm();
  
  const handleLogout = () => {
    doLogout();
  };

  useEffect(() => {
    const openHandler = () => setIsOpen(true);
    const closeHandler = () => setIsOpen(false);
    const toggleHandler = () => setIsOpen(s => !s);

    window.addEventListener('menu:open', openHandler);
    window.addEventListener('menu:close', closeHandler);
    window.addEventListener('menu:toggle', toggleHandler);

    // close on Escape
    const onKey = (e) => { if (e.key === 'Escape') setIsOpen(false); };
    window.addEventListener('keydown', onKey);

    // close on resize >1200
    const onResize = () => { if (window.innerWidth > 1200) setIsOpen(false); };
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('menu:open', openHandler);
      window.removeEventListener('menu:close', closeHandler);
      window.removeEventListener('menu:toggle', toggleHandler);
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  // lock body scroll when open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('lock-scroll');
    } else {
      document.body.classList.remove('lock-scroll');
    }
  }, [isOpen]);

  // internal close and also notify header (optional)
  const doClose = () => {
    setIsOpen(false);
    window.dispatchEvent(new CustomEvent('menu:close'));
  };

  const handleTabClick = (index) => {
    if (typeof onTabClick === 'function') onTabClick(index);
    // close the drawer on mobile immediately
    if (window.innerWidth <= 1200) {
      setTimeout(() => doClose(), 50);
    }
  };

  
  return (
    <>
      <div
        className={`sidebar-overlay ${isOpen ? 'visible' : ''}`}
        onClick={doClose}
        aria-hidden={!isOpen}
      />
      <aside className={`sidebar ${isOpen ? 'open' : ''}`} aria-hidden={!isOpen && window.innerWidth <= 1200}>
         
        <div className='header'>
          <button
            type="button"
            className={`sidebar-close ${isOpen ? 'visible' : ''}`}
            aria-label={t("aria.close_menu")}
            onClick={doClose}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
              <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </g>
            </svg>
          </button>
          <div>
            <span></span>
            <h1>AI-Novation</h1>
          </div>
          
        </div>

        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`tab-button ${activeTab === index ? 'active' : ''}`}
            onClick={() => handleTabClick(index)}
          >
            <img src={activeTab === index ? tab.icon[1] : tab.icon[0]} alt="" className="tab-icon" />
            {/* Названия вкладок уже приходят переведенными из CabinetPage */}
            {tab.label} 
          </button>
        ))}
        <div className='sidebar-footer-banner'>
          <img src={brainIcon} alt="" />
          <h3>{t("banner.title")}</h3>
          <p>{t("banner.description")}</p>
          <button onClick={leadFormState.openForm}>{t("banner.button")}</button>
        </div>
        <div className="sidebar-footer">
          
          <button className="logout-button" onClick={handleLogout}>
            <img src={icon} alt={t("logout_alt")} width={20}/> <span>{t("logout")}</span>
          </button>
        </div>
      </aside>

      <LeadModal formState={leadFormState} />
    </>
  );
};

export default Sidebar;